
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-to-expect",
      function () {
        return require("private-next-pages/what-to-expect.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-to-expect"])
      });
    }
  